<template>
  <div class="min-h-screen-safe bg-slate-900 font-sans text-slate-200 flex flex-col">
    
    <header class="flex-none sticky top-0 z-50 bg-[#0B1021]/95 backdrop-blur-md border-b border-slate-800 pt-safe flex flex-col shadow-lg">
      <div class="px-3 py-3 flex items-center justify-between relative">
        <NuxtLink :to="localePath('/')" class="flex items-center gap-1 text-slate-400 hover:text-white transition-colors group p-1 z-10">
          <svg class="w-6 h-6 transform group-hover:-translate-x-1 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
          <span class="text-[14px] font-bold tracking-wider">{{ locale === 'zh' ? '返回首页' : 'Home' }}</span>
        </NuxtLink>
        <h1 class="absolute left-1/2 -translate-x-1/2 font-bold text-[15px] sm:text-[16px] text-white tracking-widest uppercase pointer-events-none w-max">
          {{ locale === 'zh' ? '免责声明' : 'Disclaimer' }}
        </h1>
        <div class="w-16"></div>
      </div>
    </header>

    <main class="flex-auto max-w-3xl mx-auto w-full p-5 pb-safe">
      <DisclaimerZh v-if="locale === 'zh'" />
      <DisclaimerEn v-else />
      <div class="h-12"></div>
    </main>

  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import DisclaimerZh from '~/components/disclaimer/DisclaimerZh.vue'
import DisclaimerEn from '~/components/disclaimer/DisclaimerEn.vue'

const { locale } = useI18n()

// 🚀 引入路径智能转换引擎
const localePath = useLocalePath()

// 🚀 注入富含马票/万字关键词的安全信任 SEO 矩阵
const seoData = computed(() => {
  const isZh = locale.value === 'zh'
  return {
    title: isZh 
      ? '免责声明 (Disclaimer) | 马新最快 4D 万字与马票开奖平台 - Lottobox' 
      : 'Disclaimer | Fastest Malaysia & Singapore 4D Results - Lottobox',
    description: isZh
      ? 'Lottobox Live 仅提供第三方 4D 万字与马票开奖资讯及摇珠直播查询服务，绝不提供任何形式的在线博彩交易、买字或投注服务。保障彩民数据安全。'
      : 'Lottobox Live is strictly an independent 4D results and broadcast live draw information provider. We do not offer any online betting or gambling services.',
    keywords: '免责声明, disclaimer, Lottobox, 万字, 马票, 4D results, 查万字, 查马票, 买字防骗, 4D live draw'
  }
})

useHead(() => ({
  title: seoData.value.title,
  meta: [
    { name: 'description', content: seoData.value.description },
    { name: 'keywords', content: seoData.value.keywords }
  ]
}))
</script>
